import React from "react";
import {
  Button,
  FormControl,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { Form } from "../../../Base/views/ModalPopUpForm";
import { useState } from "react";
import { grey } from "@mui/material/colors";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Mention, MentionsInput } from "react-mentions";
import MentionInputStyles from "./MentionStyles/MentionInputStyles";
import { GetEmployeesAction } from "../../../../../store/Employee/Employee/Action";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import {
  GetReportListHelper,
} from "../../../Ancillary/ReportScheduler/helper/ReportSchedulerHelper";
import { UpdateReportScheduleAction } from "../../../../../store/Ancillary/ReportScheduler/Action";

const ReportShcedulerConfigPopUp = ({ editedRecord, setOpenPopup }) => {
  const dispatch = useDispatch();
  const [scheduleReport, setScheduleReport] = useState({
    reports_list: "",
    schedule_id: "",
    occurence: "",
  });
  const [errors, setErrors] = useState({});
  const [mentionUsers, setMentionUsers] = useState([]);
  const [mentionTo, setMentionTo] = useState("");
  const [selectedDays, setSelectedDays] = useState([]);
  const [message, setMessage] = useState(""); 
  const { employees_options } = useSelector(
    (state) => state.EmployeeReducer.EmployeesReducer
  );
  const { report_schedule_data } = useSelector(state => state?.AncillaryReducer?.ReportSchedulerReducer);
  const [scheduleType, setScheduleType] = useState({ load: true, values: [] });
  const [reportData, setReportData] = useState({
    load: true,
    values: [],
  });
  
  const handleReportList = () => {
    try {
      GetReportListHelper().then((res) => {
       if (res?.data?.statuscode === 200) {
            const configuredIds = report_schedule_data?.map((item) => +item.reports_list) || [];
            const repList = res?.data?.data?.filter((item) => !configuredIds.includes(+item.reports_list))
        setReportData({ load: false, values: repList });
       }
     });
    } catch (err) {
      setReportData({ load: false, values: [] });
    }
  }
  useEffect(() => {
    dispatch(GetEmployeesAction({ is_active: true }));
    setScheduleType({
      load: false,
      values: [
        {
          schedule_id: "1",
          occurence: "Daily",
        },
        {
          schedule_id: "2",
          occurence: "Weekly",
        },
      ],
    });
        // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
 useEffect(() => {
   if (scheduleReport?.schedule_id?.occurence === "Daily") {
    setMessage("Daily report for the prior date will be sent at 9am.");
  } else if (scheduleReport?.schedule_id?.occurence === "Weekly") {
     if (!selectedDays?.length) {
      setMessage("Please select at least one day of the week.");
    } else {
      setMessage(`Report for the prior date will be sent on ${selectedDays?.join(", ")} at 9am.`);
    }
  } else {
    setMessage(""); 
  }
  }, [scheduleReport?.schedule_id, selectedDays]);
   const handleDaySelection = (event, day) => {
      if (!day) return;
        setSelectedDays((prev) =>
          prev.includes(day)
            ? prev.filter((d) => d !== day)
            : [...prev, day]
      );
    };
const validate = (fieldValues) => {
    let temp = { ...errors };
    if ("reports_list" in fieldValues) {
        temp.reports_list = fieldValues.reports_list ? "" : "Report is required";
    }
    if ("schedule_id" in fieldValues) {
        temp.schedule_id = fieldValues.schedule_id ? "" : "Schedule Type is required";
    }
    if ("mentionTo" in fieldValues) {
        temp.mentionTo = mentionTo.trim() ? "" : "Email is required";
    }
    if (scheduleReport?.schedule_id?.occurence === "Weekly") {
        temp.selectedDays = selectedDays?.length ? "" : "Please select at least one day of the week";
    }
    setErrors({
        ...temp,
    });

    return Object.values(temp).every((x) => x === "");
};
  const handleInputChange = (event, value) => {
    if (["reports_list", "schedule_id"].includes(event)) {
      const updatedScheduleReport = { ...scheduleReport, [event]: value };
      if (event === "schedule_id" && value?.occurence === "Daily") {
      setSelectedDays([]); 
    }
    setScheduleReport(updatedScheduleReport)
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...scheduleReport, [event]: value });
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    if (event.type === "submit" || event.which === 13) {  
        if (validate({...scheduleReport, mentionTo})) {
            dispatch(UpdateReportScheduleAction({
              ...scheduleReport,email: mentionTo, 
              days_of_week: scheduleReport?.schedule_id?.occurence === "Weekly" ? selectedDays?.join(",") : ""}));
            setOpenPopup(false);
        }
      }
  };
  const handleChange = (e, name) => {
    const inputValue = e.target.value;
    const endsWithSpace = inputValue.endsWith(" ");
    if (endsWithSpace) {
      const trimmedValue = inputValue.trim();
      const updatedValue = trimmedValue + ",";
      setMentionTo(updatedValue);
    } else {
      setMentionTo(inputValue);
    }
  };

  useEffect(() => {
    let arr = [];
    employees_options?.forEach((temp) => {
      if (temp?.office_email) {
        arr.push({
          ...temp,
          id: temp?.office_email,
          display: temp?.office_email,
        });
      }
    });
    setMentionUsers(arr);
  }, [employees_options]);
  useEffect(() => {
    if( editedRecord) {
        setMentionTo(editedRecord?.email)
        setScheduleReport({...scheduleReport,
            schedule_id: editedRecord?.occurence? {
                schedule_id: editedRecord?.occurence === "Daily" ? "1" : "2",
                occurence : editedRecord?.occurence} : "",
            reports_list : editedRecord?.reports_list ? {
                reports_list: editedRecord?.reports_list,
                reports_list_name: editedRecord?.reports_list_name
            } : "",
          })
          setSelectedDays(editedRecord?.days_of_week ? editedRecord?.days_of_week?.split(",") : [])  
    }
        // eslint-disable-next-line react-hooks/exhaustive-deps
  },[editedRecord])
 
  return (
    <>
      <Form onSubmit={(e) => handleSubmit(e)}>
        <Grid container>
          <Grid container spacing={1.5}>
            <Grid item xs={12} md={12}>
              <FormControl fullWidth>
                <SelectableSearch
                  label="Report"
                  value={scheduleReport?.reports_list}
                   loading={() => {
                    handleReportList();
                  }}
                  fieldLabel="reports_list_name"
                  required={true}
                  variant={"outlined"}
                  name="reports_list"
                  size="small"
                  onChangeEvent={handleInputChange}
                  data={reportData}
                  {...(errors.reports_list && {
                    error: true,
                    helperText: errors.reports_list,
                  })}
                />
              </FormControl>
            </Grid>
            {/* Dropdown for Daily or Weekly */}
            <Grid item xs={12} md={12}>
              <FormControl fullWidth>
                <SelectableSearch
                  required
                  label="Schedule Type"
                  value={scheduleReport?.schedule_id}
                  loading={() => {}}
                  fieldLabel="occurence"
                  autoFocus={false}
                  variant={"outlined"}
                  name="schedule_id"
                  size="small"
                  onChangeEvent={handleInputChange}
                  data={scheduleType}
                  {...(errors.schedule_id && {
                    error: true,
                    helperText: errors.schedule_id,
                  })}
                />
              </FormControl>
            </Grid>
            {/* Day Selection for Weekly */}
            {scheduleReport?.schedule_id?.occurence === "Weekly" && (
              <Grid item xs={12} md={12}>
                 <ToggleButtonGroup
                  value={selectedDays}
                  exclusive
                  onChange={(event, day) => handleDaySelection(event, day)}
                  aria-label="Day selection"
                  fullWidth
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  {[
                    { short: "S", full: "Sunday" },
                    { short: "M", full: "Monday" },
                    { short: "T", full: "Tuesday" },
                    { short: "W", full: "Wednesday" },
                    { short: "T", full: "Thursday" },
                    { short: "F", full: "Friday" },
                    { short: "S", full: "Saturday" },
                  ].map((day, index) => (
                    <ToggleButton key={index} value={day.full} aria-label={day.full}
                        selected={selectedDays?.includes(day.full)}
                        sx={{
                          minWidth: "30px", 
                          height: "30px",
                          fontSize: "12px", 
                          padding: "4px", 
                          borderRadius: "4px", 
                           "&.Mui-selected": {
                            backgroundColor: "primary.main", 
                            color: "#fff", 
                            "&:hover": {
                              backgroundColor: "primary.dark", 
                            },
                          },
                        }}
                    >
                      {day.short}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
                 {errors.selectedDay && (
                    <Typography mt={1} pl={1.5}  fontSize="12px" color="error">
                      {errors.selectedDay}
                    </Typography>
                  )}
              </Grid>
            )}
            {/* Message */}
            {message && (
              <Grid item xs={12} md={12} mb={-1}>
                <Typography pl={1.5} variant="body2" color="textSecondary">
                  {message}
                </Typography>
              </Grid>
            )}
            <Grid key="emails" item xs={12} md={12} mt={-2}>
                 <div
                  style={{
                    position: "relative",
                    zIndex: 4,
                    margin: "1px 0px 0px 3px",
                  }}
                >
                <MentionsInput
                    fullWidth
                    style={MentionInputStyles}
                    value={mentionTo}
                    name="mentionTo"
                    onChange={(e, name) => handleChange(e, "mentionTo")}
                    placeholder={"Email"}
                    autoFocus={false}
                >
                    <Mention
                    markup="__id__,"
                    displayTransform={(office_email) => `${office_email}, `}
                    data={mentionUsers.filter(user => {
                      const escapedEmail = user.id.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                      const emailRegex = new RegExp(`\\b${escapedEmail}\\b`, 'i');
                      return !emailRegex.test(mentionTo);
                    })}
                    displayName="office_email"
                    />
                </MentionsInput>
                <Typography
                  pl={1.5}
                  mt={-1.5}
                  fontSize="12px"
                  color="text.secondary"
                >
                  Use <strong>@</strong> to mention an email or enter multiple email addresses separated by commas (,).
                </Typography>
                <Typography mt={0.5} pl={1.5} fontSize={"12px"} color="error">{errors?.mentionTo}</Typography>
                </div>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              sx={{
                marginTop: "1rem",
                marginRight: "1rem",
                ":hover": { color: grey[50] },
              }}
              variant="outlined"
              onClick={() => setOpenPopup(false)}
              className="mpl-secondary-btn"
            >
              cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              className="mpl-primary-btn"
              sx={{ marginTop: "1rem", marginRight: "1rem" }}
            >
              {editedRecord ? "Update" : "Save"}
            </Button>
          </Grid>
        </Grid>
      </Form>
    </>
  );
};

export default ReportShcedulerConfigPopUp;